import {
  getCommcommunityAll,
  getPointLevelThreeListById
} from "@/api/point.js";
import {
  getPublicServiceTypeListAll
} from "@/api/block.js";
export default {
  data() {
    return {
      commcommunityList: [],
      blockList: [],
      publicServiceTypeList: []
    }
  },
  mounted() {
    this.getCommcommunityAllFun()
    this.getPublicServiceTypeListAllFun()
  },
  methods: {
    commcommunityChange(value) {
      this.getblockAllByCommunityIdFun(value);
    },
    // 社区列表
    async getCommcommunityAllFun() {
      const res = await getCommcommunityAll();
      this.commcommunityList = res.data.data;
    },
    // 网格列表
    async getblockAllByCommunityIdFun(id) {
      const res = await getPointLevelThreeListById({
        id: id
      });
      this.blockList = res.data.data;
    },
    // 网格列表
    async getPublicServiceTypeListAllFun(id) {
      const res = await getPublicServiceTypeListAll();
      this.publicServiceTypeList = res.data.data;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/streetInfo/blockOrganization/index.js